export default {"src":"/_next/static/media/icon-line-button.3f51de1b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};